<template>
  <list-item
    :card="item"
    :fields="['date', 'listingType', 'price']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #image>
      <card-image :image-url="item.thumbnail || item.image" />
    </template>

    <template #info>
      <div class="sales-list-item-info">
        <div class="platform-text">
          <span>{{ item.platform }}</span><span v-if="item.seller"> - {{ item.seller }}</span>
        </div>
        <div class="item-text">{{ item.title }}</div>
        <div class="actions" v-if="$slots.default">
          <slot />
        </div>
      </div>
    </template>

  </list-item>
</template>

<script>
import CardImage from './CardImage';
import ListItem from './ListItem';

export default {
  components: {
    CardImage,
    ListItem,
  },

  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.platform-text {
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.5;
  letter-spacing: 1px;
}

.item-text {
  font-weight: bold;
  font-size: 18px;
  flex: 1;

  @media($large-up) {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 60px;
  }
}

.actions {
  margin-top: $gp * .5;
}

.sales-list-item-info {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
